<div class="dialog">
  <div
    mat-dialog-title
    class="title"
    style="display: flex"
  >
    <span style="width: 560px">
      <b> {{ this.imageText[currentImageIndex] }}</b>
    </span>

    <span
      mat-dialog-actions
      class="action-buttons"
      style="width: 300px"
    >
      <button
        mat-stroked-button
        (click)="onPrevImage()"
        disabled="{{ currentImageIndex === 0 }}"
      >
        Previous
      </button>

      <button
        mat-stroked-button
        (click)="onNextImage()"
        disabled="{{ currentImageIndex === images.length - 1 }}"
      >
        Next
      </button>

      <button
        mat-stroked-button
        (click)="onClose()"
      >
        Close
      </button>
    </span>
  </div>

  <img
    src="{{ this.images[currentImageIndex] }}"
    alt=""
    width="900px"
  />
</div>
